import { useCallback, useState } from 'react'
import type { PerformanceViewMode } from './performance.types'

const STORAGE_KEY = 'vwam:tracker:performance:view-mode'

function isPerformanceViewMode(value: unknown): value is PerformanceViewMode {
  return value === 'expanded' || value === 'focused'
}

function readStoredViewMode(): PerformanceViewMode {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return isPerformanceViewMode(raw) ? raw : 'expanded'
  } catch {
    return 'expanded'
  }
}

export function usePerformanceViewMode(): [
  PerformanceViewMode,
  (mode: PerformanceViewMode) => void,
] {
  const [viewMode, setViewMode] =
    useState<PerformanceViewMode>(readStoredViewMode)

  const setPersistedViewMode = useCallback((mode: PerformanceViewMode) => {
    setViewMode(mode)
    try {
      localStorage.setItem(STORAGE_KEY, mode)
    } catch {
      // Storage unavailable (private mode, quota); in-memory state still updates.
    }
  }, [])

  return [viewMode, setPersistedViewMode]
}
